import { render, staticRenderFns } from "./PosTransactionTypeForm.vue?vue&type=template&id=c9b86900&"
import script from "./PosTransactionTypeForm.vue?vue&type=script&lang=js&"
export * from "./PosTransactionTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports